import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../utils/baseQueryWithAuth';

export interface Category {
  category_id: number;
  name: string;
  description?: string;
  salon_id?: number;
  created_at?: string;
  updated_at?: string;
}

export const categoriesApi = createApi({
  reducerPath: 'categoriesApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Categories'],
  endpoints: (builder) => ({
    // Endpoint pour récupérer toutes les catégories publiques
    publicAllCategories: builder.query<Category[], void>({
      query: () => `/api/categories/public/public_all_categories/`,
      providesTags: ['Categories']
    }),
  }),
});

export const {
  usePublicAllCategoriesQuery
} = categoriesApi;
